import React, { SVGAttributes, useState } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconZoomIn: React.FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 426.667 426.667">
      <g>
        <g>
          <g>
            <polygon
              points="234.667,106.667 192,106.667 192,192 106.667,192 106.667,234.667 192,234.667 192,320 234.667,320 
				234.667,234.667 320,234.667 320,192 234.667,192 			"
            />
            <path
              d="M213.333,0C95.68,0,0,95.68,0,213.333s95.68,213.333,213.333,213.333H384c23.573,0,42.667-19.093,42.667-42.667V213.333
				C426.667,95.68,330.987,0,213.333,0z M213.333,384c-94.08,0-170.667-76.587-170.667-170.667S119.253,42.667,213.333,42.667
				S384,119.253,384,213.333S307.413,384,213.333,384z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconZoomIn;
